import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { ContentIconProps } from './icon-atoms.types';

const ContentIcon: React.FC<ContentIconProps> = ({
  className,
  contentType,
  fill,
  backgroundFill,
  width = 32,
  height = 32,
}) => {
  switch (contentType) {
    case 'all':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="All content icon"
          viewBox="0 0 15 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>All</title>
          <rect width={width} height={height} rx="2" fillOpacity="0.9" />
          <path d="M9 18C4.03728 18 0 13.9623 0 8.99912C0 4.03768 4.03728 0 9 0C13.9627 0 18 4.03768 18 8.99912C17.9982 13.9623 13.9609 18 9 18ZM9 1.22049C4.71016 1.22049 1.2186 4.71063 1.2186 8.99912C1.2186 13.2894 4.71017 16.7795 8.99823 16.7795C13.2863 16.7795 16.7779 13.2894 16.7779 8.99912C16.7779 4.71063 13.2881 1.22049 9 1.22049ZM9.70644 16.5181C5.99588 16.5181 2.97763 13.4996 2.97763 9.78864C2.97763 6.07948 5.99588 3.05917 9.70644 3.05917C13.417 3.05917 16.4352 6.07771 16.4352 9.78864C16.4352 13.4996 13.417 16.5181 9.70644 16.5181ZM9.70644 4.2461C6.6511 4.2461 4.16444 6.733 4.16444 9.78864C4.16444 12.846 6.6511 15.3329 9.70644 15.3329C12.7635 15.3329 15.2502 12.846 15.2502 9.78864C15.2502 6.733 12.7635 4.2461 9.70644 4.2461ZM8.99823 13.5508C6.50628 13.5508 4.47881 11.5231 4.47881 9.03091C4.47881 6.54048 6.50628 4.5128 8.99823 4.5128C11.4902 4.5128 13.5159 6.54048 13.5159 9.03091C13.5159 11.5231 11.4902 13.5508 8.99823 13.5508ZM8.99823 5.66441C7.14207 5.66441 5.6303 7.17633 5.6303 9.03268C5.6303 10.889 7.14207 12.4009 8.99823 12.4009C10.8544 12.4009 12.3662 10.889 12.3662 9.03268C12.3662 7.17457 10.8544 5.66441 8.99823 5.66441Z" />
        </svg>
      );
    case 'watch':
    case 'video':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Video content icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Video</title>
          <rect width={width} height={height} rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 17.5C6.25 16.2574 7.25736 15.25 8.5 15.25H19.6429C20.8855 15.25 21.8929 16.2574 21.8929 17.5V23.5C21.8929 24.7426 20.8855 25.75 19.6429 25.75H8.5C7.25736 25.75 6.25 24.7426 6.25 23.5V17.5ZM8.5 16.75C8.08579 16.75 7.75 17.0858 7.75 17.5V23.5C7.75 23.9142 8.08579 24.25 8.5 24.25H19.6429C20.0571 24.25 20.3929 23.9142 20.3929 23.5V17.5C20.3929 17.0858 20.0571 16.75 19.6429 16.75H8.5Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.154 16.5529C25.5811 16.3923 26.0598 16.4513 26.4353 16.7107C26.8109 16.9703 27.0354 17.3975 27.0359 17.8541L27.0359 23.7145C27.0357 24.1711 26.8117 24.5989 26.4364 24.859C26.0611 25.1191 25.5822 25.1787 25.1546 25.0186L20.8797 23.4156C20.587 23.3058 20.3931 23.026 20.3931 22.7134V18.8579C20.3931 18.5453 20.587 18.2654 20.8797 18.1557L25.154 16.5529C25.1538 16.553 25.1543 16.5528 25.154 16.5529ZM21.8931 19.3777V22.1936L25.5359 23.5596V18.0117L21.8931 19.3777Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.46436 18.5713C9.46436 18.1571 9.80014 17.8213 10.2144 17.8213H17.2858C17.7 17.8213 18.0358 18.1571 18.0358 18.5713C18.0358 18.9855 17.7 19.3213 17.2858 19.3213H10.2144C9.80014 19.3213 9.46436 18.9855 9.46436 18.5713Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 10.2143C6.25 8.02487 8.02487 6.25 10.2143 6.25C12.4037 6.25 14.1786 8.02487 14.1786 10.2143C14.1786 12.4037 12.4037 14.1786 10.2143 14.1786C8.02487 14.1786 6.25 12.4037 6.25 10.2143ZM10.2143 7.75C8.8533 7.75 7.75 8.8533 7.75 10.2143C7.75 11.5753 8.8533 12.6786 10.2143 12.6786C11.5753 12.6786 12.6786 11.5753 12.6786 10.2143C12.6786 8.8533 11.5753 7.75 10.2143 7.75Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.25 10.8576C15.25 9.02319 16.7371 7.53613 18.5714 7.53613C20.4058 7.53613 21.8929 9.02319 21.8929 10.8576C21.8929 12.6919 20.4058 14.179 18.5714 14.179C16.7371 14.179 15.25 12.6919 15.25 10.8576ZM18.5714 9.03613C17.5655 9.03613 16.75 9.85161 16.75 10.8576C16.75 11.8635 17.5655 12.679 18.5714 12.679C19.5774 12.679 20.3929 11.8635 20.3929 10.8576C20.3929 9.85161 19.5774 9.03613 18.5714 9.03613Z"
          />
        </svg>
      );

    case 'audio':
    case 'podcast':
    case 'listen':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Audio content icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Audio</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8374 19.9834C16.2516 19.9834 16.5874 20.3192 16.5874 20.7334V25.7275C16.5874 26.1417 16.2516 26.4775 15.8374 26.4775C15.4232 26.4775 15.0874 26.1417 15.0874 25.7275V20.7334C15.0874 20.3192 15.4232 19.9834 15.8374 19.9834Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4868 25.7285C12.4868 25.3143 12.8226 24.9785 13.2368 24.9785H18.439C18.8532 24.9785 19.189 25.3143 19.189 25.7285C19.189 26.1427 18.8532 26.4785 18.439 26.4785H13.2368C12.8226 26.4785 12.4868 26.1427 12.4868 25.7285Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.33496 12.4922C9.74917 12.4922 10.085 12.828 10.085 13.2422V15.7392C10.085 18.0546 12.0491 19.9833 14.5371 19.9833H17.1382C19.6262 19.9833 21.5903 18.0546 21.5903 15.7392V13.2422C21.5903 12.828 21.9261 12.4922 22.3403 12.4922C22.7545 12.4922 23.0903 12.828 23.0903 13.2422V15.7392C23.0903 18.9401 20.3963 21.4833 17.1382 21.4833H14.5371C11.279 21.4833 8.58496 18.9401 8.58496 15.7392V13.2422C8.58496 12.828 8.92075 12.4922 9.33496 12.4922Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4935 6.25128C14.5081 6.25043 14.5227 6.25 14.5373 6.25H17.1384C17.153 6.25 17.1676 6.25043 17.1822 6.25128C19.0839 6.36267 20.5882 7.93428 20.4895 9.8299V15.4067C20.5882 17.3024 19.0839 18.874 17.1822 18.9854C17.1676 18.9862 17.153 18.9866 17.1384 18.9866H14.5373C14.5227 18.9866 14.5081 18.9862 14.4935 18.9854C12.5918 18.874 11.0875 17.3024 11.1862 15.4067V9.8299C11.0875 7.93428 12.5918 6.36267 14.4935 6.25128ZM14.5609 7.75C13.4315 7.82653 12.625 8.7489 12.6849 9.76499C12.6858 9.7797 12.6862 9.79443 12.6862 9.80916V15.4275C12.6862 15.4422 12.6858 15.4569 12.6849 15.4717C12.625 16.4877 13.4315 17.4101 14.5608 17.4866H17.1149C18.2443 17.4101 19.0507 16.4877 18.9908 15.4717C18.9899 15.4569 18.9895 15.4422 18.9895 15.4275V9.80916C18.9895 9.79443 18.9899 9.7797 18.9908 9.76499C19.0507 8.7489 18.2443 7.82653 17.1149 7.75H14.5609Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.186 10.7461C11.186 10.3319 11.5218 9.99609 11.936 9.99609H14.5371C14.9513 9.99609 15.2871 10.3319 15.2871 10.7461C15.2871 11.1603 14.9513 11.4961 14.5371 11.4961H11.936C11.5218 11.4961 11.186 11.1603 11.186 10.7461Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3882 10.7461C16.3882 10.3319 16.724 9.99609 17.1382 9.99609H19.7393C20.1535 9.99609 20.4893 10.3319 20.4893 10.7461C20.4893 11.1603 20.1535 11.4961 19.7393 11.4961H17.1382C16.724 11.4961 16.3882 11.1603 16.3882 10.7461Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.186 13.2422C11.186 12.828 11.5218 12.4922 11.936 12.4922H14.5371C14.9513 12.4922 15.2871 12.828 15.2871 13.2422C15.2871 13.6564 14.9513 13.9922 14.5371 13.9922H11.936C11.5218 13.9922 11.186 13.6564 11.186 13.2422Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3882 13.2422C16.3882 12.828 16.724 12.4922 17.1382 12.4922H19.7393C20.1535 12.4922 20.4893 12.828 20.4893 13.2422C20.4893 13.6564 20.1535 13.9922 19.7393 13.9922H17.1382C16.724 13.9922 16.3882 13.6564 16.3882 13.2422Z"
          />
        </svg>
      );

    case 'event':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Event icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Event</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25 10.7119C7.25 9.46927 8.25736 8.46191 9.5 8.46191H23.0853C24.328 8.46191 25.3353 9.46927 25.3353 10.7119V22.0859C25.3353 23.3285 24.328 24.3359 23.0853 24.3359H9.5C8.25736 24.3359 7.25 23.3285 7.25 22.0859V10.7119ZM9.5 9.96191C9.08579 9.96191 8.75 10.2977 8.75 10.7119V22.0859C8.75 22.5001 9.08579 22.8359 9.5 22.8359H23.0853C23.4996 22.8359 23.8353 22.5001 23.8353 22.0859V10.7119C23.8353 10.2977 23.4996 9.96191 23.0853 9.96191H9.5Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25 13.6348C7.25 13.2206 7.58579 12.8848 8 12.8848H24.5853C24.9996 12.8848 25.3353 13.2206 25.3353 13.6348C25.3353 14.049 24.9996 14.3848 24.5853 14.3848H8C7.58579 14.3848 7.25 14.049 7.25 13.6348Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4229 6.25C12.8371 6.25 13.1729 6.58579 13.1729 7V10.8699C13.1729 11.2841 12.8371 11.6199 12.4229 11.6199C12.0086 11.6199 11.6729 11.2841 11.6729 10.8699V7C11.6729 6.58579 12.0086 6.25 12.4229 6.25Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1626 6.25C20.5768 6.25 20.9126 6.58579 20.9126 7V10.8699C20.9126 11.2841 20.5768 11.6199 20.1626 11.6199C19.7484 11.6199 19.4126 11.2841 19.4126 10.8699V7C19.4126 6.58579 19.7484 6.25 20.1626 6.25Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5669 16.6749C10.5669 16.108 11.0264 15.6484 11.5933 15.6484C12.1602 15.6484 12.6197 16.108 12.6197 16.6749C12.6197 17.2417 12.1602 17.7013 11.5933 17.7013C11.0264 17.7013 10.5669 17.2417 10.5669 16.6749Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5669 20.546C10.5669 19.9791 11.0264 19.5195 11.5933 19.5195C12.1602 19.5195 12.6197 19.9791 12.6197 20.546C12.6197 21.1128 12.1602 21.5724 11.5933 21.5724C11.0264 21.5724 10.5669 21.1128 10.5669 20.546Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2661 16.6749C15.2661 16.108 15.7257 15.6484 16.2925 15.6484C16.8594 15.6484 17.319 16.108 17.319 16.6749C17.319 17.2417 16.8594 17.7013 16.2925 17.7013C15.7257 17.7013 15.2661 17.2417 15.2661 16.6749Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2661 20.546C15.2661 19.9791 15.7257 19.5195 16.2925 19.5195C16.8594 19.5195 17.319 19.9791 17.319 20.546C17.319 21.1128 16.8594 21.5724 16.2925 21.5724C15.7257 21.5724 15.2661 21.1128 15.2661 20.546Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9653 16.6749C19.9653 16.108 20.4249 15.6484 20.9918 15.6484C21.5586 15.6484 22.0182 16.108 22.0182 16.6749C22.0182 17.2417 21.5586 17.7013 20.9918 17.7013C20.4249 17.7013 19.9653 17.2417 19.9653 16.6749Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9653 20.546C19.9653 19.9791 20.4249 19.5195 20.9918 19.5195C21.5586 19.5195 22.0182 19.9791 22.0182 20.546C22.0182 21.1128 21.5586 21.5724 20.9918 21.5724C20.4249 21.5724 19.9653 21.1128 19.9653 20.546Z"
          />
        </svg>
      );

    case 'addToCalendar':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Add to calendar icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Coming soon</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            d="M12.5 21.5H6.5C5.67157 21.5 5 20.8284 5 20V8C5 7.17157 5.67157 6.5 6.5 6.5H20C20.8284 6.5 21.5 7.17157 21.5 8V12.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 11H21.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M9.5 8V5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 8V5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5 27.5C24.8137 27.5 27.5 24.8137 27.5 21.5C27.5 18.1863 24.8137 15.5 21.5 15.5C18.1863 15.5 15.5 18.1863 15.5 21.5C15.5 24.8137 18.1863 27.5 21.5 27.5Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5 18.5V24.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.5 21.5H24.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'tool':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Tool icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Tool</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4615 8.6772L12.9926 11.7401C13.1115 11.977 13.1733 12.2385 13.1731 12.5036L13.1731 23.0001C13.1731 23.9453 12.4068 24.7116 11.4615 24.7116C10.5163 24.7116 9.75 23.9453 9.75 23.0001L9.75 12.5041C9.74981 12.239 9.81162 11.977 9.93048 11.7401L11.4615 8.6772ZM10.2401 7.76587C10.4713 7.30311 10.9442 7.01074 11.4615 7.01074C11.9789 7.01074 12.4517 7.30311 12.683 7.76587C12.683 7.76597 12.6829 7.76577 12.683 7.76587L14.3334 11.0675C14.3334 11.0677 14.3333 11.0673 14.3334 11.0675C14.5569 11.5134 14.6734 12.0058 14.6731 12.5046V23.0001C14.6731 24.7738 13.2352 26.2116 11.4615 26.2116C9.68786 26.2116 8.25 24.7738 8.25 23.0001V12.5043C8.25 12.5043 8.25 12.5044 8.25 12.5043C8.24973 12.0057 8.36597 11.5137 8.58945 11.068L10.2401 7.76587ZM11.3412 8.43656C11.3413 8.4366 11.3412 8.43651 11.3412 8.43656V8.43656Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.31982 11.9229C8.31982 11.5086 8.65561 11.1729 9.06982 11.1729H13.8534C14.2676 11.1729 14.6034 11.5086 14.6034 11.9229C14.6034 12.3371 14.2676 12.6729 13.8534 12.6729H9.06982C8.65561 12.6729 8.31982 12.3371 8.31982 11.9229Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 22.3848C8.25 21.9706 8.58579 21.6348 9 21.6348H13.9231C14.3373 21.6348 14.6731 21.9706 14.6731 22.3848C14.6731 22.799 14.3373 23.1348 13.9231 23.1348H9C8.58579 23.1348 8.25 22.799 8.25 22.3848Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8652 8.5C16.8652 7.25736 17.8726 6.25 19.1152 6.25H23.4998C24.7425 6.25 25.7499 7.25736 25.7499 8.5V23.9615C25.7499 25.2042 24.7425 26.2115 23.4998 26.2115H19.1152C17.8726 26.2115 16.8652 25.2042 16.8652 23.9615V8.5ZM19.1152 7.75C18.701 7.75 18.3652 8.08579 18.3652 8.5V23.9615C18.3652 24.3758 18.701 24.7115 19.1152 24.7115H23.4998C23.9141 24.7115 24.2498 24.3758 24.2498 23.9615V8.5C24.2498 8.08579 23.9141 7.75 23.4998 7.75H19.1152Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8652 10.6924C16.8652 10.2782 17.201 9.94238 17.6152 9.94238H20.0768C20.491 9.94238 20.8268 10.2782 20.8268 10.6924C20.8268 11.1066 20.491 11.4424 20.0768 11.4424H17.6152C17.201 11.4424 16.8652 11.1066 16.8652 10.6924Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8652 14.3848C16.8652 13.9706 17.201 13.6348 17.6152 13.6348H20.0768C20.491 13.6348 20.8268 13.9706 20.8268 14.3848C20.8268 14.799 20.491 15.1348 20.0768 15.1348H17.6152C17.201 15.1348 16.8652 14.799 16.8652 14.3848Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8652 18.0771C16.8652 17.6629 17.201 17.3271 17.6152 17.3271H20.0768C20.491 17.3271 20.8268 17.6629 20.8268 18.0771C20.8268 18.4914 20.491 18.8271 20.0768 18.8271H17.6152C17.201 18.8271 16.8652 18.4914 16.8652 18.0771Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8652 21.7695C16.8652 21.3553 17.201 21.0195 17.6152 21.0195H20.0768C20.491 21.0195 20.8268 21.3553 20.8268 21.7695C20.8268 22.1837 20.491 22.5195 20.0768 22.5195H17.6152C17.201 22.5195 16.8652 22.1837 16.8652 21.7695Z"
          />
        </svg>
      );

    case 'news':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="News content icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>News</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.1798 9C23.1798 8.72085 23.0248 8.46479 22.7774 8.33542C22.53 8.20604 22.2313 8.22475 22.002 8.38397L21.2032 8.93873L21.2031 8.93877C18.7552 10.6383 15.8841 11.5459 12.949 11.5523C12.939 11.552 12.929 11.5518 12.9189 11.5518H11.3338C9.43194 11.5518 7.94189 13.1488 7.94189 15.0537C7.94189 16.9587 9.43194 18.5557 11.3338 18.5557H12.2135C12.3781 19.9311 12.9945 21.2185 13.9762 22.1912C14.2705 22.4828 14.7453 22.4806 15.0369 22.1863C15.3284 21.8921 15.3262 21.4172 15.032 21.1257C14.3443 20.4444 13.8898 19.5494 13.7314 18.5795C16.3922 18.7308 18.9733 19.6218 21.2032 21.17L22.002 21.7248C22.2313 21.884 22.53 21.9027 22.7774 21.7733C23.0248 21.6439 23.1798 21.3879 23.1798 21.1087V9ZM13.6689 13.0346C16.511 12.8996 19.2713 12.0008 21.6798 10.4261V19.6826C19.2713 18.1079 16.511 17.2092 13.6689 17.0742V13.0346ZM9.44189 15.0537C9.44189 13.9189 10.3175 13.0518 11.3338 13.0518H12.1689V17.0557H11.3338C10.3175 17.0557 9.44189 16.1886 9.44189 15.0537ZM24.5435 13.2041C24.9577 13.2041 25.2935 13.5399 25.2935 13.9541V16.1557C25.2935 16.5699 24.9577 16.9057 24.5435 16.9057C24.1292 16.9057 23.7935 16.5699 23.7935 16.1557V13.9541C23.7935 13.5399 24.1292 13.2041 24.5435 13.2041Z"
          />
        </svg>
      );

    case 'download':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Download icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Download</title>
          <rect width={width} height={height} rx="2" fillOpacity="0.9" />
          <path d="M24 12.7059H19.4286V6H12.5714V12.7059H8L16 20.5294L24 12.7059ZM8 22.7647V25H24V22.7647H8Z" />
        </svg>
      );

    case 'externalLink':
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="External link icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          data-testid="external-link-content-icon"
        >
          <title>External link</title>
          <rect width={width} height={height} rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8125 7.75C18.8125 7.33579 19.1483 7 19.5625 7H24.625C25.0392 7 25.375 7.33579 25.375 7.75V12.8125C25.375 13.2267 25.0392 13.5625 24.625 13.5625C24.2108 13.5625 23.875 13.2267 23.875 12.8125V8.5H19.5625C19.1483 8.5 18.8125 8.16421 18.8125 7.75Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.1553 7.21967C25.4482 7.51256 25.4482 7.98744 25.1553 8.28033L13.9053 19.5303C13.6124 19.8232 13.1376 19.8232 12.8447 19.5303C12.5518 19.2374 12.5518 18.7626 12.8447 18.4697L24.0947 7.21967C24.3876 6.92678 24.8624 6.92678 25.1553 7.21967Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 12.25C7 11.2145 7.83947 10.375 8.875 10.375H15.625C16.0392 10.375 16.375 10.7108 16.375 11.125C16.375 11.5392 16.0392 11.875 15.625 11.875H8.875C8.66789 11.875 8.5 12.0429 8.5 12.25V23.5C8.5 23.7071 8.66789 23.875 8.875 23.875H20.125C20.3321 23.875 20.5 23.7071 20.5 23.5V16.75C20.5 16.3358 20.8358 16 21.25 16C21.6642 16 22 16.3358 22 16.75V23.5C22 24.5355 21.1605 25.375 20.125 25.375H8.875C7.83947 25.375 7 24.5355 7 23.5V12.25Z"
          />
        </svg>
      );
    case 'article':
    default:
      return (
        <svg
          width={width}
          height={height}
          className={className}
          aria-label="Article content icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Article</title>
          <rect width="32" height="32" rx="2" fillOpacity="0.9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.57163 13.5975C7.60645 13.0791 8.02924 12.689 8.51597 12.7261C10.3719 12.8675 12.2036 13.2588 13.9672 13.8905C14.4297 14.0562 14.6786 14.5898 14.523 15.0824C14.3674 15.575 13.8664 15.84 13.4039 15.6743C11.7817 15.0932 10.097 14.7333 8.38986 14.6032C7.90314 14.5661 7.5368 14.1159 7.57163 13.5975Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.57163 17.5975C7.60645 17.0791 8.02924 16.689 8.51597 16.7261C10.3719 16.8675 12.2036 17.2588 13.9672 17.8905C14.4297 18.0562 14.6786 18.5898 14.523 19.0824C14.3674 19.575 13.8664 19.84 13.4039 19.6743C11.7817 19.0932 10.097 18.7333 8.38986 18.6032C7.90314 18.5661 7.5368 18.1159 7.57163 17.5975Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4284 13.5975C24.3936 13.0791 23.9708 12.689 23.484 12.7261C21.6281 12.8675 19.7964 13.2588 18.0328 13.8905C17.5703 14.0562 17.3214 14.5898 17.477 15.0824C17.6326 15.575 18.1336 15.84 18.5961 15.6743C20.2183 15.0932 21.903 14.7333 23.6101 14.6032C24.0969 14.5661 24.4632 14.1159 24.4284 13.5975Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4284 17.5975C24.3936 17.0791 23.9708 16.689 23.484 16.7261C21.6281 16.8675 19.7964 17.2588 18.0328 17.8905C17.5703 18.0562 17.3214 18.5898 17.477 19.0824C17.6326 19.575 18.1336 19.84 18.5961 19.6743C20.2183 19.0932 21.903 18.7333 23.6101 18.6032C24.0969 18.5661 24.4632 18.1159 24.4284 17.5975Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8.93823C14.8933 8.19989 12.02 6.79948 6.07584 6.72367C5.94159 6.72205 5.81242 6.77285 5.71798 6.86441C5.6226 6.95637 5.56915 7.08089 5.56935 7.21063V22.5748C5.56711 22.8377 5.78435 23.0541 6.05824 23.0618C10.7781 23.1229 13.5646 24.0148 15.0693 24.7495C15.4637 24.9421 15.77 25.1238 16 25.277V8.93823ZM7.06935 8.25066V21.5872C10.7357 21.7284 13.2502 22.3679 14.9166 23.0414C14.9683 23.0623 15.0192 23.0832 15.0693 23.1042V10.1222C14.7967 9.94941 14.382 9.72154 13.7946 9.48367C12.5084 8.96291 10.3756 8.38723 7.06935 8.25066Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8.93823C17.1067 8.19989 19.98 6.79948 25.9242 6.72367C26.0584 6.72205 26.1876 6.77285 26.282 6.86441C26.3774 6.95637 26.4308 7.08089 26.4306 7.21063V22.5748C26.4329 22.8377 26.2156 23.0541 25.9418 23.0618C21.2219 23.1229 18.4354 24.0148 16.9307 24.7495C16.5363 24.9421 16.23 25.1238 16 25.277V8.93823ZM24.9306 8.25066V21.5872C21.2643 21.7284 18.7498 22.3679 17.0834 23.0414C17.0317 23.0623 16.9808 23.0832 16.9307 23.1042V10.1222C17.2033 9.94941 17.618 9.72154 18.2054 9.48367C19.4916 8.96291 21.6244 8.38723 24.9306 8.25066Z"
          />
        </svg>
      );
  }
};

const ContentIconAtom = styled(ContentIcon)`
  fill: ${({ fill }) => (fill ? fill : vars.coreDarkGrey)};
  rect {
    fill: ${({ backgroundFill }) =>
      backgroundFill ? backgroundFill : 'white'};
  }
`;

export default ContentIconAtom;
